import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1ABB9C', // O verde principal do SigaPsi
            dark: '#129A80', // Verde ao passar o rato (hover)
            contrastText: '#fff',
        },
        secondary: {
            main: '#2A3F54', // O azul escuro da barra lateral
            contrastText: '#fff',
        },
        background: {
            default: '#F7F7F7', // Cor de fundo padrão das páginas
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        button: {
            textTransform: 'none', // Impede que os botões fiquem TUDO EM MAIÚSCULAS
            fontWeight: 600,
        },
    },
    components: {
        // Automatizar todos os Botões
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '8px', // Todos os botões arredondados
                    boxShadow: 'none',   // Remove sombras antigas
                    '&:hover': {
                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                    },
                },
            },
        },
        // Automatizar todos os Painéis (Fundos brancos)
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: '12px', // Caixas mais arredondadas
                    boxShadow: '0 2px 10px rgba(0,0,0,0.03)', // Sombra global subtil
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    borderRadius: 0, // Força a barra lateral a ser reta (quadrada)
                },
            },
        },
        // Automatizar as Caixas de Texto (Inputs)
        MuiTextField: {
            defaultProps: {
                size: 'small', // Fica mais elegante por defeito, ótimo para mobile
            },
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '8px', // Bordas dos inputs arredondadas
                        backgroundColor: '#fafafa',
                    },
                },
            },
        },
    },
});

export default theme;